module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABYElEQVRYR+2Yu0oDQRSGvwQCqYQQ7fIAQdLY+QQpfQCrPIEg9ikCNjaCwcZKXyFlKkuxTpfKd/AGCVEOJLCMO5uJZzI7C3Ngi4U5c/75/rkwUyPyqEWujyRQ61ClCDaBS6AHpVn/A8yAW+Bb6GcJ9oGB1hJP+Y/A1BR4Clx4KqDt5g54MQUKzbO1xXVthX/mr9YWTwCxu7S55qy/UqvYeVQhGyaCWtqVI3gEDIEF8JH53o3/V+BTS8cl3yTYAW62JL4BI+DLpYC2jSmwBdwXdCrirgEhGiRMgQ3gyVI5T9wxcA4ceFK7OUnkLF7aThIRKEKzYSM3BtqexGW7eQCebQLFYrF6E0W2liJQFoksFoltc64Ui2Wb6TqI24Ozf7vM26ivgMPQq9U22jyBJ8A85FZSZEXljrog82qXIongLrTy2iaCPglGf+2M/uIe/dNH9I9H2vm8l/y0zWixJoJagr978Ucpdd0xYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menuLogo.png
// module id = M9E3
// module chunks = 23